/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FixedSizeList as List } from "react-window";
import { useSelector } from "react-redux";
import Select, { components } from "react-select";
import { putTreatment } from "../../../connections/putTreatment";
import useDebounce from "../../../utils/hooks";
import { getAllMedicine } from "../../../connections/getAllMedicine";
import { useQuery } from "@tanstack/react-query";
import { getAllDiagnoses } from "../../../connections/getAllDiagnoses";
import { getSpecialInstruction } from "../../../connections/getSpecialInstruction";
import { getMedicalTest } from "../../../connections/getMedicalTest";
import { getMedicineDescription } from "../../../connections/getMedicineDescription";
import { getMedicineRemarks } from "../../../connections/getMedicineRemarks";
import { Search } from "@mui/icons-material";
import { CloseIcon } from "yet-another-react-lightbox";
import CreatableSelect from "react-select/creatable";
import { getAllFormType } from "../../../connections/getAllFormType";
import { getMedicineSalt } from "../../../connections/getMedicineSalt";

const UpdateTreatMent = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [formState, setFormState] = useState({});
  const [diagnosisOptions, setDiagnosisOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [medicineInput, setMedicineInput] = useState("");
  const [removedMedicine, setRemovedMedicine] = useState([]);
  const [medicinesAttributes, setMedicinesAttributes] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [medSaltInput, setMedSaltInput] = useState("");
  const [specialIntInput, setSpecialIntInput] = useState("");
  const handleAddMedicineTreatment = (e) => {
    e.preventDefault();
    setMedicinesAttributes((prev) => [
      ...prev,
      {
        medicine_id: "",
        medicine_description: [],
        medicine_remark: [],
      },
    ]);
  };
  const handleRemoveMedicine = (e, idx, el) => {
    e.preventDefault();

    const newRow = [...medicinesAttributes];
    // const removed = medicinesAttributes?.find((_, index) => index === idx) && {
    //   medicine_id: medicinesAttributes[idx]?.medicine_id,
    //   medicine_description: medicinesAttributes[idx]?.medicine_description,
    //   medicine_remark: medicinesAttributes[idx]?.medicine_remark,
    //   id: medicinesAttributes[idx]?.id,
    //   _destroy: "1", // 1 for remove
    // };

    if (el?.id) {
      setRemovedMedicine((prev) => [...prev, { ...el, _destroy: "1" }]);
    }
    const updatedRow = newRow?.filter((_, index) => index !== idx);
    setMedicinesAttributes(updatedRow);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const treatmentData = location.state || null;
  const { data: diagnosesData, isFetching: isLoading } = useQuery({
    queryKey: ["getAllDiagnoses", "all"],
    queryFn: () => getAllDiagnoses(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const handleChange = (name, value) => {
    if (
      name === "medicine_id" ||
      name === "medicine_description" ||
      name === "medicine_remark"
    ) {
      setFormState((prev) => ({
        ...prev,
        treatment_medicines_attributes: [
          ...(prev.treatment_medicines_attributes || []), // existing items
          { [name]: value }, // add new object with dynamic key
        ],
      }));
    } else {
      setFormState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeMedicine = (index, field, value, label, isNew) => {
    const list = [...medicinesAttributes];
    const prev = list[index];

    const prevMedId = prev?.medicine_id; // previous current med id
    const originalMedId = prev?.original_medicine_id; // ⭐ original assigned med id

    const updated = {
      ...prev,
      [field]: value,
      ...(label && { name: label }),
    };

    /*
  -----------------------------------------------------
  CASE 1 — USER SELECTS NEW MEDICINE (Creatable)
  -----------------------------------------------------
  */
    if (isNew) {
      updated.isNew = true;

      // If previous was an existing medicine → mark it removed
      if (prevMedId) {
        setRemovedMedicine((old) => {
          const exists = old.some(
            (x) => x.medicine_id === prevMedId && x.rowIndex === index
          );
          if (!exists) {
            return [...old, { ...prev, _destroy: "1", rowIndex: index }];
          }
          return old;
        });
      }

      // New medicine cannot have old id
      delete updated.medicine_id;
    } else if (!isNew && field === "medicine_id") {
      /*
  -----------------------------------------------------
  CASE 2 — USER SELECTS EXISTING MEDICINE
  -----------------------------------------------------
  */
      updated.isNew = false;
      const newMedId = value;

      // 1️⃣ If switching OLD → DIFFERENT OLD
      if (prevMedId && prevMedId !== newMedId) {
        setRemovedMedicine((old) => {
          const exists = old.some(
            (x) => x.medicine_id === prevMedId && x.rowIndex === index
          );
          if (!exists) {
            return [...old, { ...prev, _destroy: "1", rowIndex: index }];
          }
          return old;
        });
      }

      // 2️⃣ If user returns back to ORIGINAL medicine → FULL RESTORE
      if (newMedId === originalMedId) {
        setRemovedMedicine((old) => old.filter((x) => x.rowIndex !== index));
      }

      // 3️⃣ Restore this specific med if previously removed
      setRemovedMedicine((old) =>
        old.filter((item) => item.medicine_id !== newMedId)
      );
    } else if (field === "medicine_id" && !value) {
      /*
  -----------------------------------------------------
  CASE 3 — USER CLEARS FIELD
  -----------------------------------------------------
  */
      updated.name = null;
      updated.isNew = false;

      if (prevMedId) {
        setRemovedMedicine((old) => {
          const exists = old.some(
            (x) => x.medicine_id === prevMedId && x.rowIndex === index
          );
          if (!exists) {
            return [...old, { ...prev, _destroy: "1", rowIndex: index }];
          }
          return old;
        });
      }
    }

    list[index] = updated;
    setMedicinesAttributes(list);
  };

  // diagnosis options
  const options = diagnosisOptions?.map((item) => ({
    value: item.value,
    label: item.value,
  }));
  // special instructions options
  const debounceSpecialInstInput = useDebounce(specialIntInput, 1000);
  const { data: getSpeInsData, isFetching: specialInstLoader } = useQuery({
    queryKey: ["getSpecialInstruction", "all", debounceSpecialInstInput],
    queryFn: () =>
      getSpecialInstruction(
        user?.token,
        null,
        1,
        100,
        null,
        null,
        null,
        debounceSpecialInstInput
      ),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
    enabled: !!debounceSpecialInstInput,
  });
  const allSpecialInstructions =
    getSpeInsData?.payload?.special_instructions || [];
  const formattedSpecialInstructions = allSpecialInstructions?.map((el) => ({
    value: el.value,
    label: el.value,
  }));
  //medical test option for medical filed
  const [medicalInput, setMedicalInput] = useState("");
  const handleMedicalChange = (inputValue) => {
    // e.preventDefault();
    setMedicalInput(inputValue);
  };
  const { data: getAllFormTypeData } = useQuery({
    queryKey: ["getAllFormType"],
    queryFn: () => getAllFormType(user?.token),
    enabled: !!user?.token,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const dataForm = getAllFormTypeData || [];
  const formattedFormType = dataForm?.map((el) => ({
    value: el?.value,
    label: el?.label,
  }));
  const debouncedInputSalt = useDebounce(medSaltInput, 700);

  const { data: getMedSalt, isFetching: saltFetching } = useQuery({
    queryKey: ["getMedicineSalt", debouncedInputSalt],
    queryFn: () =>
      getMedicineSalt(user?.token, null, 1, 10, debouncedInputSalt),
    enabled: !!debouncedInputSalt,
    // cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const data = getMedSalt?.payload?.medicine_salts || [];
  const formattedMedSalt = data.map((el) => ({
    value: el.name,
    label: el.name,
  }));
  const debouncedInputMedicineData = useDebounce(medicalInput, 1000);
  const { data: getAllMedicalTestData, isLoading: medicalTestLoader } =
    useQuery({
      queryKey: ["getMedicalTest", "all"],
      queryFn: () =>
        getMedicalTest(user?.token, null, 1, 10, debouncedInputMedicineData),
      enabled: !!debouncedInputMedicineData,
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnReconnect: false, // Don't refetch when reconnecting
    });
  const allMedicalTest = getAllMedicalTestData?.payload?.medical_tests || [];
  const formattedMedicalTest = allMedicalTest?.map((el) => ({
    label: el.name,
    value: el.name,
  }));

  // medicine Options
  // medicine Options
  const debouncedInputMedicine = useDebounce(medicineInput, 1000);
  const { data: getAllMedicineData, isFetching: medicineFetching } = useQuery({
    queryKey: ["getAllMedicine", debouncedInputMedicine],
    queryFn: () =>
      getAllMedicine(user?.token, "q", 1, 10, debouncedInputMedicine),
    enabled: !!debouncedInputMedicine,
    // cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const allMedicine = getAllMedicineData?.payload?.medicines || [];
  const formattedMedicineOptions = allMedicine?.map((el) => ({
    value: el?.id,
    label: el.name,
  }));
  // console.log(medicinesAttributes, "medicinesAttributes");
  const MenuList = (props) => {
    const { options, children, maxHeight, getValue } = props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * 35;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={35}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  };
  const handleSearchMedSalt = (inputValue) => {
    setIsTyping(true);
    setMedSaltInput(inputValue);
  };
  // const medicineOptions = useMemo(() => formattedMedicineOptions, []);
  //medicine description
  const { data: getMedicineDescData, isLoading: medDescLoader } = useQuery({
    queryKey: ["getMedicineDescription", "all"],
    queryFn: () => getMedicineDescription(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const allMedicineDescription =
    getMedicineDescData?.payload?.medicine_descriptions || [];
  const formattedMedicineDescription = allMedicineDescription?.map((el) => ({
    value: el?.value,
    label: el.value,
  }));
  //medicine remarks options
  const { data: medicineRemarkData, isLoading: remarksLoader } = useQuery({
    queryKey: ["getMedicineRemarks", "all"],
    queryFn: () => getMedicineRemarks(user?.token, "all", null, null),
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  const allMedicineRemarks =
    medicineRemarkData?.payload?.medicine_remarks || [];
  const formattedMedicineRemarks = allMedicineRemarks?.map((el) => ({
    value: el?.value,
    label: el.value,
  }));
  // const medicineRemarkOptions = useMemo(() => formattedMedicineRemarks, []);
  const cleanObject = (obj) => {
    const cleaned = {};

    Object.entries(obj).forEach(([key, value]) => {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return; // skip invalid fields
      }

      cleaned[key] = value;
    });

    return cleaned;
  };
  const handleAddTreatment = async (e) => {
    e.preventDefault();
    const cleanedMedicinesAttributes = medicinesAttributes
      .map((item) => cleanObject(item))
      .filter((item) => Object.keys(item).length > 0);
    // Split into two arrays
    const existingMedicines = [];
    const newMedicines = [];
    console.log(cleanedMedicinesAttributes, "cleanedMedicinesAttributes");
    cleanedMedicinesAttributes.forEach((item) => {
      if (item.medicine_id) {
        existingMedicines.push({
          medicine_id: item.medicine_id,
          // ...item,
          medicine_description: item?.medicine_description,
          medicine_remark: item?.medicine_remark,
        });
      } else {
        newMedicines.push({
          name: item.name,
          form_type: item.form_type,
          salt_name: item.salt_name,
          medicine_description: item?.medicine_description,
          medicine_remark: item?.medicine_remark,
          // ...item,
          _destroy: "0",
        });
      }
    });
    const payload = {
      treatment: {
        name: formState?.name,
        self_notes: formState?.self_notes,
        diagnosis: formState?.diagnosis,
        special_instructions: formState?.special_instructions,
        // selected_medical_tests_order: "",
        medical_tests: formState?.medical_tests,
        // ...(medicinesAttributes?.length > 0 && {
        treatment_medicines_attributes: [
          ...existingMedicines,
          ...(removedMedicine?.length > 0 ? removedMedicine : []),
        ].filter(Boolean), // Remove null, undefined, or falsy values
      },
      // new medicine
      ...(newMedicines.length > 0 && {
        new_medicines: newMedicines,
      }),
    };
    if (!formState?.name) {
      toast.error("Please provide a name");
      return;
    }

    try {
      const data = await putTreatment(user?.token, payload, treatmentData?.id);
      if (data.status.status === "SUCCESS") {
        toast.success("Treatment Update Successfully");
        setFormState({});
        navigate(-1);
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };
  const debouncedInput = useDebounce(inputValue, 700);
  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);
  };
  const handleMedicineChange = (value) => {
    setIsTyping(true);
    setMedicineInput(value);
  };
  const specialInstChange = (value) => {
    setIsTyping(true);
    setSpecialIntInput(value);
  };
  // console.log(formState, "FormState");
  useEffect(() => {
    if (diagnosesData) {
      let allDiagnosis = diagnosesData?.payload?.diagnoses || [];

      const formattedDiagnosis = allDiagnosis?.map((el) => ({
        label: el,
        value: el,
      }));
      setDiagnosisOptions(formattedDiagnosis);
    }
    if (treatmentData) {
      setFormState((prev) => ({
        ...prev,
        name: treatmentData?.name,
        self_notes: treatmentData?.self_notes,
        diagnosis: treatmentData?.diagnosis,
        special_instructions: treatmentData?.special_instructions,
        medical_tests: treatmentData?.medical_tests,
      }));
      const medicinesAttributes =
        treatmentData?.treatment_medicines?.map((item, index) => ({
          medicine_id: item.medicine_id,
          medicine_description: item.medicine_description,
          medicine_remark: item.medicine_remark,
          id: item?.id,
          name: item?.name,
          _destroy: "0", // 1 for remove\
          original_medicine_id: item.medicine_id, // ⭐ IMPORTANT
          rowIndex: index, // ⭐ Track row for cleanup
        })) || [];

      // Set the extracted data in the state
      // console.log(medicinesAttributes);
      // allMedicine = [...medicinesAttributes];
      setMedicinesAttributes(medicinesAttributes);
    }
  }, [treatmentData, diagnosesData]);
  useEffect(() => {
    if (debouncedInput) {
      const optionExists = diagnosisOptions.some(
        (item) => item.value === debouncedInput
      );

      if (!optionExists) {
        const newOption = {
          value: debouncedInput,
          label: debouncedInput,
        };
        setDiagnosisOptions((prevPack) => [...prevPack, newOption]);
      }
    }
  }, [debouncedInput, diagnosisOptions]);
  console.log(medicinesAttributes, "medicinesAttributes");
  console.log(removedMedicine, "removedMedicine");
  useEffect(() => {
    if (!medicalTestLoader) {
      setIsTyping(false);
    }
    if (medicineFetching) {
      setIsTyping(false);
    }
    if (saltFetching) {
      setIsTyping(false);
    }
    if (!specialInstLoader) {
      setIsTyping(false);
    }
  }, [medicalTestLoader, medicineFetching, saltFetching, specialInstLoader]);
  // console.log(formState, "form state data");
  return (
    <>
      <Header />
      <Sidebar activeClassName="treatments-dashboard" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}>Treatment Template</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Treatment Template
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      {treatmentData?.id}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Update Treatment Template</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Name
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              value={formState?.name}
                              name="name"
                              onChange={(e) =>
                                handleChange("name", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Self notes
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <input
                              value={formState?.self_notes}
                              name="self_notes"
                              onChange={(e) =>
                                handleChange("self_notes", e.target.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Diagnosis
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <Select
                              isLoading={isLoading}
                              options={options}
                              onInputChange={handleInputChange}
                              value={formState?.diagnosis?.map((test) => ({
                                value: test,
                                label: test,
                              }))}
                              onChange={(selectedOptions) => {
                                // Ensure `selectedOptions` is transformed into an array of `value` fields
                                const selectedValues = Array.isArray(
                                  selectedOptions
                                )
                                  ? selectedOptions.map(
                                      (option) => option.value
                                    ) // Extract only `value` fields
                                  : [];

                                handleChange("diagnosis", selectedValues); // Pass the array of values to handleChange
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isMulti
                              isSearchable
                              placeholder="Choose diagnosis"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Special instructions
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <CreatableSelect
                              isLoading={specialInstLoader}
                              options={formattedSpecialInstructions}
                              value={formState?.special_instructions?.map(
                                (test) => ({
                                  value: test,
                                  label: test,
                                })
                              )}
                              onInputChange={specialInstChange}
                              onChange={(selectedOptions) => {
                                // Convert `selectedOptions` to an array of `value` fields
                                const selectedValues = Array.isArray(
                                  selectedOptions
                                )
                                  ? selectedOptions.map(
                                      (option) => option.value
                                    ) // Extract only `value` fields
                                  : [];

                                handleChange(
                                  "special_instructions",
                                  selectedValues
                                ); // Pass the array of values to handleChange
                              }}
                              // ⛔ BLOCK creation while loading OR while typing but API hasn't returned anything yet
                              isValidNewOption={(inputValue) => {
                                if (medicalTestLoader || isTyping) return false; // Block if API is loading
                                if (!inputValue) return false; // Block empty text

                                return true;
                              }}
                              formatCreateLabel={(inputValue) =>
                                medicalTestLoader
                                  ? ""
                                  : `Create new instructions "${inputValue}"`
                              }
                              components={{
                                DropdownIndicator: (props) => (
                                  <components.DropdownIndicator {...props}>
                                    <Search style={{ color: "#999" }} />
                                  </components.DropdownIndicator>
                                ),
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isMulti
                              isSearchable
                              isClearable
                              placeholder="Choose special instructions"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Medical Tests
                              {/* <span className="login-danger">*</span> */}
                            </label>
                            <CreatableSelect
                              components={{
                                DropdownIndicator: (props) => (
                                  <components.DropdownIndicator {...props}>
                                    <Search style={{ color: "#999" }} />
                                  </components.DropdownIndicator>
                                ),
                                IndicatorSeparator: () => null,
                              }}
                              onInputChange={handleMedicalChange}
                              isLoading={medicalTestLoader}
                              options={formattedMedicalTest}
                              value={formState?.medical_tests?.map((test) => ({
                                value: test,
                                label: test,
                              }))}
                              onChange={(selectedOptions) => {
                                // Convert `selectedOptions` to an array of `value` fields
                                const selectedValues = Array.isArray(
                                  selectedOptions
                                )
                                  ? selectedOptions.map(
                                      (option) => option.value
                                    ) // Extract only `value` fields
                                  : [];

                                handleChange("medical_tests", selectedValues); // Pass the array of values to handleChange
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999, // Set your desired z-index here
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "#007A99"
                                    : "rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #007A99"
                                    : "none",
                                  "&:hover": {
                                    borderColor: "rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(0deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                              isMulti
                              isSearchable
                              isClearable
                              placeholder="Choose medical test"
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Add Treatment Medicine</h4>
                          </div>
                        </div>

                        {medicinesAttributes?.length > 0 &&
                          medicinesAttributes?.map((el, index) => (
                            <React.Fragment key={index}>
                              <div className="col-6 col-md-4 col-lg-4">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      marginRight: "8px",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    <p> {index + 1}</p>
                                  </div>
                                  <div
                                    className="form-group local-forms"
                                    style={{ flex: 1, width: "100%" }}
                                  >
                                    <label>
                                      Medicine
                                      <span className="login-danger">*</span>
                                    </label>
                                    <CreatableSelect
                                      isLoading={medicineFetching}
                                      options={formattedMedicineOptions}
                                      value={
                                        formattedMedicineOptions.find(
                                          (option) =>
                                            option.value ===
                                            medicinesAttributes[index]
                                              ?.medicine_id
                                        ) ||
                                        // Fallback: create an option from medicinesAttributes[index]?.name
                                        (medicinesAttributes[index]?.name
                                          ? {
                                              value:
                                                medicinesAttributes[index]
                                                  ?.medicine_id || null,
                                              label:
                                                medicinesAttributes[index]
                                                  ?.name,
                                            }
                                          : null)
                                      }
                                      onInputChange={handleMedicineChange}
                                      onChange={(selectedOptions) => {
                                        const isNew =
                                          selectedOptions?.__isNew__ || false;
                                        handleChangeMedicine(
                                          index,
                                          isNew ? "name" : "medicine_id",
                                          selectedOptions?.value,
                                          selectedOptions?.label,
                                          isNew
                                        ); // Pass the array of values to handleChangeMedicine
                                      }}
                                      // ⛔ BLOCK creation while loading OR while typing but API hasn't returned anything yet
                                      isValidNewOption={(inputValue) => {
                                        if (medicalTestLoader || isTyping)
                                          return false; // Block if API is loading
                                        if (!inputValue) return false; // Block empty text

                                        return true;
                                      }}
                                      formatCreateLabel={(inputValue) =>
                                        medicalTestLoader
                                          ? ""
                                          : `Create new medicine "${inputValue}"`
                                      }
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 999999,
                                        }),
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          borderColor: state.isFocused
                                            ? "#007A99"
                                            : "rgba(46, 55, 164, 0.1)",
                                          boxShadow: state.isFocused
                                            ? "0 0 0 1px #007A99"
                                            : "none",
                                          "&:hover": {
                                            borderColor:
                                              "rgba(46, 55, 164, 0.1)",
                                          },
                                          borderRadius: "10px",
                                          fontSize: "14px",
                                          minHeight: "45px",
                                        }),
                                        dropdownIndicator: (base, state) => ({
                                          ...base,
                                          transform: state.selectProps
                                            .menuIsOpen
                                            ? "rotate(-180deg)"
                                            : "rotate(0)",
                                          transition: "250ms",
                                          width: "35px",
                                          height: "35px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                          fontSize: "14px",
                                        }),
                                      }}
                                      // isMulti
                                      isSearchable
                                      isClearable
                                      placeholder="Choose medicine"
                                      className="react-select"
                                      classNamePrefix="select"
                                      // components={{ MenuList }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 col-md-4 col-lg-4">
                                <div className="form-group local-forms">
                                  <label>
                                    Medicine Description
                                    <span className="login-danger">*</span>
                                  </label>
                                  <CreatableSelect
                                    isLoading={medDescLoader}
                                    options={formattedMedicineDescription}
                                    value={medicinesAttributes[
                                      index
                                    ]?.medicine_description?.map((test) => ({
                                      value: test,
                                      label: test,
                                    }))}
                                    onChange={(selectedOptions) => {
                                      // Ensure `selectedOptions` is always an array of `value` fields only
                                      const selectedValues = (
                                        Array.isArray(selectedOptions)
                                          ? selectedOptions
                                          : selectedOptions
                                          ? [selectedOptions]
                                          : []
                                      ).map((option) => option.value);

                                      handleChangeMedicine(
                                        index,
                                        "medicine_description",
                                        selectedValues
                                      ); // Pass the array of values to handleChangeMedicine
                                    }}
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999, // Set your desired z-index here
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 999999,
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                      }),
                                    }}
                                    isMulti
                                    isSearchable
                                    isClearable
                                    placeholder="Choose medicine description"
                                    className="react-select"
                                    classNamePrefix="select"
                                  />
                                </div>
                              </div>
                              <div className="col-6 col-md-3 col-lg-3">
                                <div className="form-group local-forms">
                                  <label>
                                    Medicine Remarks
                                    <span className="login-danger">*</span>
                                  </label>
                                  <CreatableSelect
                                    isLoading={remarksLoader}
                                    options={formattedMedicineRemarks}
                                    value={medicinesAttributes[
                                      index
                                    ]?.medicine_remark?.map((test) => ({
                                      value: test,
                                      label: test,
                                    }))}
                                    onChange={(selectedOptions) => {
                                      // Ensure `selectedOptions` is always an array of `value` fields only
                                      const selectedValues = (
                                        Array.isArray(selectedOptions)
                                          ? selectedOptions
                                          : selectedOptions
                                          ? [selectedOptions]
                                          : []
                                      ).map((option) => option.value);

                                      handleChangeMedicine(
                                        index,
                                        "medicine_remark",
                                        selectedValues
                                      ); // Pass the array of values to handleChangeMedicine
                                    }}
                                    // components={{ MenuList }}
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999, // Set your desired z-index here
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 999999,
                                      }),
                                      option: (base) => ({
                                        ...base,
                                        whiteSpace: "normal", // allows wrapping
                                        wordBreak: "break-word",
                                        lineHeight: "20px",
                                        paddingTop: "8px",
                                        paddingBottom: "8px",
                                        fontSize: "14px",
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                      }),
                                    }}
                                    isMulti
                                    isSearchable
                                    isClearable
                                    placeholder="Choose medicine remarks"
                                    className="react-select"
                                    classNamePrefix="select"
                                  />
                                </div>
                              </div>
                              {el?.isNew && (
                                <>
                                  <div className="col-6 col-md-4 col-lg-4">
                                    <div className="form-group local-forms">
                                      <label>
                                        Form Type
                                        <span className="login-danger">*</span>
                                      </label>
                                      <Select
                                        options={formattedFormType}
                                        value={
                                          el?.form_type
                                            ? {
                                                value: el.form_type,
                                                label:
                                                  el.form_type
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  el.form_type.slice(1),
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          handleChangeMedicine(
                                            index,
                                            "form_type",
                                            selectedOption?.value
                                          );
                                        }}
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 999999,
                                          }),
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused
                                              ? "#007A99"
                                              : "rgba(46, 55, 164, 0.1)",
                                            boxShadow: state.isFocused
                                              ? "0 0 0 1px #007A99"
                                              : "none",
                                            "&:hover": {
                                              borderColor:
                                                "rgba(46, 55, 164, 0.1)",
                                            },
                                            borderRadius: "10px",
                                            fontSize: "14px",
                                            minHeight: "45px",
                                          }),
                                          dropdownIndicator: (base, state) => ({
                                            ...base,
                                            transform: state.selectProps
                                              .menuIsOpen
                                              ? "rotate(-180deg)"
                                              : "rotate(0)",
                                            transition: "250ms",
                                            width: "35px",
                                            height: "35px",
                                          }),
                                        }}
                                        placeholder="Select form type"
                                        className="react-select"
                                        classNamePrefix="select"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-6 col-md-4 col-lg-4">
                                    <div className="form-group local-forms">
                                      <label>
                                        Medicine Salt
                                        <span className="login-danger">*</span>
                                      </label>
                                      <CreatableSelect
                                        isLoading={saltFetching}
                                        options={formattedMedSalt}
                                        onInputChange={handleSearchMedSalt}
                                        value={
                                          el?.salt_name
                                            ? {
                                                value: el.salt_name,
                                                label: el.salt_name,
                                              }
                                            : null
                                        }
                                        onChange={(selectedOption) => {
                                          handleChangeMedicine(
                                            index,
                                            "salt_name",
                                            selectedOption?.value
                                          );
                                        }}
                                        // ⛔ BLOCK creation while loading OR while typing but API hasn't returned anything yet
                                        isValidNewOption={(inputValue) => {
                                          if (medicalTestLoader || isTyping)
                                            return false; // Block if API is loading
                                          if (!inputValue) return false; // Block empty text

                                          return true;
                                        }}
                                        formatCreateLabel={(inputValue) =>
                                          medicalTestLoader
                                            ? ""
                                            : `Create new  "${inputValue}"`
                                        }
                                        // onCreateOption={(inputValue) => {
                                        //   handleChangeMedicine(
                                        //     index,
                                        //     "medicine_salt_name",
                                        //     inputValue
                                        //   );
                                        // }}
                                        styles={{
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 999999,
                                          }),
                                          control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: state.isFocused
                                              ? "#007A99"
                                              : "rgba(46, 55, 164, 0.1)",
                                            boxShadow: state.isFocused
                                              ? "0 0 0 1px #007A99"
                                              : "none",
                                            "&:hover": {
                                              borderColor:
                                                "rgba(46, 55, 164, 0.1)",
                                            },
                                            borderRadius: "10px",
                                            fontSize: "14px",
                                            minHeight: "45px",
                                          }),
                                          dropdownIndicator: (base, state) => ({
                                            ...base,
                                            transform: state.selectProps
                                              .menuIsOpen
                                              ? "rotate(-180deg)"
                                              : "rotate(0)",
                                            transition: "250ms",
                                            width: "35px",
                                            height: "35px",
                                          }),
                                        }}
                                        isSearchable
                                        isClearable
                                        placeholder="Choose or create medicine salt"
                                        className="react-select"
                                        classNamePrefix="select"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="col-6 col-md-1 col-lg-1">
                                <button
                                  style={{
                                    maxWidth: "150px",
                                    height: "45px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={(e) =>
                                    handleRemoveMedicine(e, index, el)
                                  }
                                  className="btn btn-primary submit-form form-control mb-4"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            </React.Fragment>
                          ))}
                        <div className="col-12 col-md-12 col-xl-12">
                          <button
                            style={{ width: "20%" }}
                            className="btn btn-primary submit-form me-2 form-control"
                            onClick={handleAddMedicineTreatment}
                          >
                            Add New Item
                          </button>
                        </div>
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleAddTreatment}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/admin/prescription/treatments");
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};
export default UpdateTreatMent;
